<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page

========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onClickReset)" autocomplete="off">
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row">
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center text-center">
                  <span class="mx-auto text-big text-white">RiskVision</span>

                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                  <div class="p-8">
                    <div class="vx-card__title mb-8">
                      <h4 class="mb-4">Reset Password</h4>
                      <p>Please enter your new password.</p>
                    </div>
                    <vs-input readonly type="email" label-placeholder="Email" v-model="form.email" class="w-full mb-6"/>
                    <ValidationProvider vid="password" name="password" rules="required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8" v-slot="{ errors }">
                      <vs-input name="password" type="password" label-placeholder="Password" v-model="form.password" class="w-full mb-6" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                    <ValidationProvider vid="password_confirmation" name="password_confirmation" rules="same_password:@password|required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8" v-slot="{ errors }">
                      <vs-input name="password_confirmation" type="password" label-placeholder="Confirm Password" v-model="form.password_confirmation"
                                class="w-full mb-8" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>

                    <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                      <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go
                        Back To Login
                      </vs-button>
                      <vs-button button="submit" class="w-full sm:w-auto">Reset</vs-button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import store from "../../store/store";

  const StaffRepository = RepositoryFactory.get('staff');

  export default {
    mixins: [SuccessMessage, ErrorMessages],
    data() {
      return {
        form: {
          email: '',
          password: '',
          password_confirmation: '',
          token: ''
        }
      }
    },
    async mounted() {
      console.log("reset password page mounted")
      await this.getPasswordToken()
    },
    methods: {
      async onClickReset() {
        this.$vs.loading();
        try {
          const {data} = (await StaffRepository.passwordReset(this.form)).data;
          this.showSuccessMessage('Password Reset successfully. Please login!');
          // this.$router.push('/pages/login')
        } catch (err) {
          this.convertAndNotifyError(err)
        }
        this.$vs.loading.close()
      },
      async getPasswordToken() {
        this.$vs.loading();
        try {
          const {data} = (await StaffRepository.getForgotPasswordToken(this.id = this.$route.params.token));
          console.log("forgot password token", data)
          this.form.email = data.email
          this.form.token = data.token
        } catch (err) {
          this.convertAndNotifyError(err)
          // this.$router.push('/pages/login')
        }
        this.$vs.loading.close()
      }
    }
  }
</script>
